import { SERIA_PLUS_V3_IMAGE_BASE_URL, createDescription, createSlideMarkers, createTab } from './utils';

export const balconiesTab = createTab({
  slides: [
    {
      ...createDescription([
        'В кварталах «Серии плюс» представлены балконы разных форм.',
        'Снаружи они придают фасадам особую динамику, а в квартире',
        'появляется дополнительная зона отдыха.',
      ]),
      imageAlt: 'Балконы с отделкой керамогранитом в квартале Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/balconies/1.webp`,
      markers: createSlideMarkers([
        {
          left: 440,
          tooltip: { placement: 'top', text: 'Ограждение из безопасного многослойного стекла' },
          top: 604,
        },
        {
          left: 600,
          tooltip: { placement: 'right', text: 'Отделка керамогранитом' },
          top: 662,
        },
        {
          left: 1190,
          tooltip: { placement: 'top', text: 'Внутрипольные конвекторы у выходов на балкон' },
          top: 813,
        },
      ]),
    },
    {
      ...createDescription([
        'Треугольные, полукруглые и трапециевидные балконы оживляют',
        'фасад и делают здание узнаваемым, а в квартире создают',
        'уникальное пространство для отдыха.',
      ]),
      imageAlt: 'Французский и фигурный балконы в квартале Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/balconies/2.webp`,
      markers: createSlideMarkers([
        {
          left: 874,
          tooltip: { placement: 'right', text: 'Французский балкон' },
          top: 362,
        },
        {
          left: 1112,
          tooltip: { placement: 'right', text: 'Фигурный балкон' },
          top: 391,
        },
      ]),
    },
    {
      ...createDescription([
        'Ограждения выполнены из высокопрочного стекла или металла',
        'с антикоррозийным покрытием — они не мешают обзору и долго',
        'сохраняют внешний вид.',
      ]),
      imageAlt: 'Открытый балкон в квартале Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/balconies/3.webp`,
      markers: createSlideMarkers([
        {
          left: 653,
          tooltip: { placement: 'right', text: 'Открытый балкон' },
          top: 355,
        },
      ]),
    },
    {
      ...createDescription([
        'Закрытые балконы можно использовать, как летнюю террасу,',
        'поставить любимые цветы или наслаждаться утренней чашкой кофе',
        'на свежем воздухе.',
      ]),
      imageAlt: 'Закрытый балкон в квартале Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/balconies/4.webp`,
      markers: createSlideMarkers([
        {
          left: 881,
          tooltip: { placement: 'right', text: 'Закрытый балкон' },
          top: 451,
        },
      ]),
    },
  ],
  title: 'Балконы',
});
